import type { ComponentProps, MouseEvent } from 'react';

interface AppLinkProps extends ComponentProps<'a'> {
  href: string;
  onNavigate: (path: string) => void;
}

/**
 * Ссылка внутри приложения.
 *
 * Настоящий <a href>, а не кнопка с обработчиком: работают Cmd/Ctrl+клик,
 * средняя кнопка мыши, «открыть в новой вкладке» из контекстного меню и
 * предпросмотр адреса в строке состояния. Обычный левый клик перехватываем —
 * перезагружать страницу целиком незачем.
 */
export function AppLink({
  href,
  onNavigate,
  onClick,
  ...props
}: AppLinkProps): JSX.Element {
  return (
    <a
      href={href}
      onClick={(event: MouseEvent<HTMLAnchorElement>) => {
        onClick?.(event);
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }
        event.preventDefault();
        onNavigate(href);
      }}
      {...props}
    />
  );
}
